export function getImageNameFromURI(uri: string) {
  console.log('----------------------')
  let paths = uri.split('/')
  let imageName = paths[paths.length - 1]
  let formattedImageName = imageName.replaceAll('%20', ' ')
  return formattedImageName
}
